module.exports = __webpack_public_path__ + "img/740.9d1e215e.png";